import styled from "styled-components"
import { mobile } from "../../Responsive"

export const Container = styled.div`
    display: flex;

    ${mobile({ flexDirection: "column" })}
`
